document.addEventListener("DOMContentLoaded", () => {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) {
      console.error("Елемент #cart-drawer не знайдено в DOM!");
      return;
    }
  
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          // Перевіряємо, чи є атрибут open
          if (cartDrawer.hasAttribute("open")) {
            console.log("Корзина відкрита!");
            // Ховаємо елементи
  
            const widget1 = document.getElementById("ecomsend-widget")
            if(widget1){
              widget1.style.display = "none"
            }
            const widget3 = document.getElementById("tidio-chat")
            if(widget3){
              widget3.style.display = "none"
            }
            
            const widget2 = document.querySelector(".loox-pn");
            if (widget2) {
              // Робимо елемент невидимим
              widget2.style.zIndex = -1;
            }
            
          } else {
            console.log("Корзина закрита!");
            const widget1 = document.getElementById("ecomsend-widget")
            if(widget1){
              widget1.style.display = "";
            }
            const widget3 = document.getElementById("tidio-chat")
            if(widget3){
              widget3.style.display = ""
            }
            const widget2 = document.querySelector(".loox-pn");
            if (widget2) {
              // Робимо елемент невидимим
              widget2.style.zIndex = 9999;
            }
          }
        }
      });
    });
  

    const config = {
      attributes: true,
      attributeFilter: ["open"],
    };

    observer.observe(cartDrawer, config);

    const leaveTime = localStorage.getItem("leaveTime");
    console.log("date", Date.now() - leaveTime, leaveTime && Date.now() - leaveTime >= 15000)
    if (leaveTime && Date.now() - leaveTime >= 10000 && !localStorage.getItem("viewCartCustomer")) {
        checkCart();
    }
});


function checkCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length > 0) {
        document.querySelector('[aria-controls="cart-drawer"]')?.click();
        localStorage.setItem("viewCartCustomer", true)
      } else {
        localStorage.removeItem("viewCartCustomer")
      }
    });
}

  

document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
        localStorage.setItem("leaveTime", Date.now());
    }
});

document.querySelectorAll('.lsdev-buy-it-now').forEach(button => {
    button.addEventListener('click', function() {
        let form = this.closest('.shopify-product-form'); // Знаходимо батьківську форму
        let formData = new FormData(form); // Отримуємо дані з цієї форми

        fetch('/cart/add', {
          method: 'POST',
          body: formData
        }).then(response => {
          if (response.ok) {
            window.location.href = '/checkout';
          }
        });
    });
});

// document.getElementById("lsdev-buy-it-now").addEventListener("click", function() {
//     var form = document.querySelector("form[action^='/cart/add']");
//     if (form) {
//       var formData = new FormData(form);
//       fetch('/cart/add', {
//         method: 'POST',
//         body: formData
//       }).then(response => {
//         if (response.ok) {
//           window.location.href = '/checkout';
//         }
//       });
//     }
//   });
